<template>
  <header class="header">
    <h1>Anelise Chagas</h1>
    <h2>Psicóloga Clínica · CRP 12/28457</h2>
  </header>
</template>

<style scoped>
.header {
  text-align: center;
  padding: 60px 20px;
  background: #e8eff2;
}
.header h1 {
  font-size: 3rem;
  margin: 0;
  color: #2c5e6e;
}
.header h2 {
  margin-top: 10px;
  font-weight: 400;
  color: #3a6f7c;
}
</style>
